import axios from './axiosHttp'
const buildtype = process.env.NODE_ENV
console.log(buildtype)
let baseUrl = ""
switch (buildtype) {
  case 'production': //生产
    baseUrl="https://sdd.huidr.com/sdd/api"
    break;
  case 'development': //开发
    baseUrl="https://sdd.test.huidr.com/sdd/api"
    // baseUrl="http://192.168.1.176:1089"
    // baseUrl="http://192.168.1.150:1089"
    // baseUrl="http://192.168.1.143:1089"  // 王勇
    // baseUrl="http://manager.springcloud-dev.192.168.1.201.xip.io/api"
    // baseUrl="https://manager.test.huidr.com/api"
    // baseUrl="https://manager.huidr.com/api"

    // baseUrl="/"
    break;
  case 'test': //测试
    // baseUrl="http://192.168.1.120:8080/JsonTest/api"

    baseUrl="https://sdd.test.huidr.com/sdd/api"
    break;
  case 'LOCAL':
    baseUrl="https://sdd.test.huidr.com/sdd/api";
    break;
}
let server = {
  requestAjax(ajax) {
    console.log(ajax)
    return axios({
      url: baseUrl,
      method:ajax.method,
      data: JSON.stringify(ajax.data),
      headers:ajax.headers || { 'Content-Type': 'application/json' },
      responseType: ajax.responseType
    })
  },
  sendAjax(ajax) {
    return new Promise(resolve => {
      axios({
        url: baseUrl,
        method:ajax.method,
        data: JSON.stringify(ajax.data),
        headers: ajax.headers ||{ 'Content-Type': 'application/json' },
        responseType: ajax.responseType
      })
          .then((res) => {
            console.log(res)
          })
    })
  },
  /**
   *
   * @param {Object} params
   * 请求格式为{
   *    request: [
   *        query: {
   *          type: 'xxx',
   *          data: data,
   *        }
   *    ]
   * }
   */
  requestFn(params) {
    axios({
      url: params.url,
      method: 'POST',
      data: JSON.stringify(params.data),
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      console.log(res.data.response)
    })
  },
}

export default server